import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MAINTENANCE_BANNER = createFcmDetails('maintenance_banner', {
	owner: 'Site platform',
	context: 'All pages',
	description: 'Use to display a custom maintenance message',
	import: false,
});
